import { useEffect, useState } from "react";
import { manageWorkforceSchema } from "./ManageWorkforce.schema";

const WorkforceValidation = (states, ...props) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error === null) {
      const statesArray = Object.keys(states);
      const er = {};
      for (let i = 0; i < statesArray.length; i++) {
        er[statesArray[i]] = null;
      }
      setError(er);
    }
  }, [states]);

  const checkValidator = (keyArr = null) => {
    const statesArray = keyArr ? [keyArr] : Object.keys(states);
    let result = {};

    statesArray.map((key, i) => {
      const schema = manageWorkforceSchema[key];
      if (schema?.required) {
        if (
          schema.properties?.empty &&
          (states[key] === "" || states[key] === null)
        ) {
          result = {
            ...result,
            [key]: schema.properties?.empty,
          };
        } else if (
          schema.properties?.number &&
          states[key] &&
          isNaN(states[key])
        ) {
          result = {
            ...result,
            [key]: schema.properties?.number,
          };
        } else if (
          schema.properties?.minLength &&
          states[key] &&
          states[key].length < schema.properties?.minLength.limit
        ) {
          result = {
            ...result,
            [key]: schema.properties?.minLength.msg,
          };
        }else if (
          schema.properties?.maxLength &&
          states[key] &&
          states[key].length > schema.properties?.maxLength?.limit
        ) {
          result = {
            ...result,
            [key]: schema.properties?.maxLength?.msg,
          };
        }  else if (
          schema.properties?.positive &&
          states[key] &&
          parseInt(states[key]) < 0
        ) {
          result = {
            ...result,
            [key]: schema.properties?.positive,
          };
        } else {
          result = {
            ...result,
            [key]: null,
          };
        }
        return null;
      } else {
        result = {
          ...result,
          [key]: null,
        };
      }
    });

    setError({ ...error, ...result });
  };

  const resetAllValidator = (key) => {
    setError(null);
  };

  const resetValidator = (key) => {
    setError({
      ...error,
      [key]: false,
    });
  };

  const isError = () => {
    if (error === null) return true;
    const statesArray = Object.keys(states);
    for (let i = 0; i < statesArray.length; i++) {
      if (error[statesArray[i]]) {
        return true;
      }
    }
    for (let i = 0; i < statesArray.length; i++) {
      if (!states[statesArray[i]]) {
        return true;
      }
    }
    return false;
  };

  return [error, checkValidator, resetValidator, resetAllValidator, isError];
};

export default WorkforceValidation;
